import compose from 'crocks/helpers/compose';
import constant from 'crocks/combinators/constant';
import isFunction from 'crocks/predicates/isFunction';
import propPathOr from 'crocks/helpers/propPathOr';
import propOr from 'crocks/helpers/propOr';
import unless from 'crocks/logic/unless';

const safeRenderer =
  constant('');

const ensureFunction =
  unless(isFunction, safeRenderer);

const getCustomRenderer =
  propOr(safeRenderer, 'render');

const getColumnRenderer =
  propPathOr(safeRenderer, ['column', 'customFn']);

const getRenderFn =
  compose(ensureFunction, getCustomRenderer);

const getCustomFn =
  compose(ensureFunction, getColumnRenderer);

export const custom = args => (
  getRenderFn(args) ||
  getCustomFn(args) ||
  safeRenderer
)(args);
